import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { login } from "@/lib/admin-api";

export default function AdminLogin() {
    const [email, setEmail] = useState("admin@eclipsecubiertas.com");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Admin · Eclipse Cubiertas";
        let robotsTag = document.querySelector('meta[name="robots"]');
        if (!robotsTag) {
            robotsTag = document.createElement("meta");
            robotsTag.setAttribute("name", "robots");
            document.head.appendChild(robotsTag);
        }
        robotsTag.setAttribute("content", "noindex, nofollow");
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !password) return toast.error("Ingresa email y contraseña");
        setSubmitting(true);
        try {
            const res = await login(email, password);
            localStorage.setItem("admin_token", res.access_token);
            localStorage.setItem("admin_user", JSON.stringify(res.user));
            toast.success(`Bienvenido, ${res.user.nombre || res.user.email}`);
            navigate("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Credenciales inválidas");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-eclipse-primary flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="flex flex-col items-center leading-none">
                        <span className="font-display font-black text-3xl tracking-tight text-white">ECLIPSE</span>
                        <span className="font-display font-medium text-[11px] tracking-[0.35em] text-eclipse-cta">CUBIERTAS</span>
                    </div>
                </div>
                <form onSubmit={submit} className="bg-white rounded-sm p-8 shadow-2xl">
                    <h1 className="font-display font-black text-2xl text-eclipse-primary mb-2">Panel administrativo</h1>
                    <p className="text-sm text-eclipse-muted mb-6">Acceso restringido al equipo Eclipse</p>
                    <div className="space-y-4">
                        <div>
                            <Label className="text-xs font-display font-semibold text-eclipse-primary tracking-wider uppercase mb-1.5 block">Email</Label>
                            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" required />
                        </div>
                        <div>
                            <Label className="text-xs font-display font-semibold text-eclipse-primary tracking-wider uppercase mb-1.5 block">Contraseña</Label>
                            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" required />
                        </div>
                        <Button type="submit" disabled={submitting} data-testid="admin-login-submit" className="w-full btn-eclipse-cta py-6 text-sm uppercase tracking-wider rounded-sm">
                            {submitting ? "Validando..." : (<><LogIn className="w-4 h-4 mr-2" />Entrar</>)}
                        </Button>
                    </div>
                </form>
                <p className="text-center text-white/40 text-xs mt-6 flex items-center justify-center gap-1.5">
                    <Lock className="w-3 h-3" />
                    Conexión segura · Sesiones de 12h
                </p>
            </div>
        </div>
    );
}
